<template>
  <div>
    <component
      :is="currentDeviceComponent"
      :devices="devices"
      :defaultDevices="selectedDevices"
      v-if="!loading && !error && devices.length"
    ></component>
    <div v-else class="loader">
      <StretchLoader v-if="!error" />
    </div>
  </div>
</template>

<script>
import Devices from '@/components/Devices.vue'
import DevicePlunge from '@/components/devices/Plunge.vue'
import DeviceFlume from '@/components/devices/Flume.vue'
import DeviceWell from '@/components/devices/Well.vue'
import DeviceBubbler from '@/components/devices/Bubbler.vue'
import DeviceRiver from '@/components/devices/River.vue'
import { DEVICES_QUERY } from '@/constants/graphql'

export default {
  name: 'SensorData',
  props: ['deviceType'],
  data () {
    return {
      error: false,
      devices: [],
      loading: 0
    }
  },
  computed: {
    selectedDevices () {
      let selectedDevices = []
      this.devices.forEach((device) => {
        if (this.deviceType === device.type) {
          selectedDevices.push({
            name: device.site.name + ' (Device: ' + device.name + ')',
            deviceName: device.name,
            serial: device.serial,
            site: device.site
          })
        }
      })
      return selectedDevices
    },
    currentDeviceComponent () {
      let componentName = 'Device' + this.deviceType.charAt(0).toUpperCase() + this.deviceType.slice(1)
      return (Object.keys(this.$options.components).indexOf(componentName) > -1) ? componentName : Devices
    }
  },
  components: {
    Devices,
    DevicePlunge,
    DeviceFlume,
    DeviceWell,
    DeviceBubbler,
    DeviceRiver
  },
  apollo: {
    devices: {
      query: DEVICES_QUERY,
      fetchPolicy: 'network-only'
    }
  }
}
</script>
